import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker, DesktopTimePicker } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import FormControlLabel from '@mui/material/FormControlLabel';
import Autocomplete from '@mui/material/Autocomplete';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import {useTranslation} from "react-i18next";
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import React, {Fragment} from 'react';
import {observer} from 'mobx-react';
import { DateTime } from "luxon";
import {getShortSpecName, getCityName} from './Trans.js';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import MonthSelect from './MonthSelect.js';
import {COMM_OK} from './WsR2.js';

const ntype_list = [
// 	{id: 0, type: 'none'},
// 	{id: 1, type: 'world'},
// 	{id: 2, type: 'continent'},
// 	{id: 3, type: 'country'},
	{id: 4, type: 'association'},
	{id: 5, type: 'city'},
	{id: 6, type: 'order'},
	{id: 7, type: 'family'},
	{id: 8, type: 'genus'},
	{id: 9, type: 'species'},
	{id: 10, type: 'date'},
	{id: 11, type: 'day+month'},
	{id: 12, type: 'month'},
	{id: 13, type: 'time'},
	{id: 14, type: 'user'}
];

function DaySelect(props) {
	const {month, day, dayChange} = props;
	let i, ret = [];
	
	if (!props.visible)
		return null;

	const max_d = month === 2 ? 29 : (month === 4 || month === 6 || month === 9 || month === 11) ? 30 : 31;

	for (i = 0; i < max_d; i++)
		ret.push({id: i + 1, val: i + 1});

	return (<Select native
		    size='small'
		    value={day}
		    onChange={dayChange}
		    sx={props.sx}
		>
			{ret.map((val, i) => {
				return (<option value={val.id} key={val.id}>{val.val}</option>);
			})}
		</Select>
	);
}

const DetValueDayMonthPicker = observer((props) => {
	const gStorage = useGlobalStorage();
	const ne = gStorage.notify.notification.elem[props.ind];

	function monthChange(e) {
		gStorage.notify.setTgtEMonth(props.ind, parseInt(e.target.value, 10));
	}

	function dayChange(e) {
		gStorage.notify.setTgtEDay(props.ind, parseInt(e.target.value, 10));
	}

	if (ne.t_id !== 11 && ne.t_id !== 12)
		return null;

	return (
		<Fragment>
			<MonthSelect 
				sx={{m:1, width:180}}
				month={ne.val_obj.month}
				nonone={true}
				monthChange={monthChange} 
				/>
			<DaySelect 
				sx={{m:1, width:84}}
				visible={ne.t_id !== 12}
				month={ne.val_obj.month}
				day={ne.val_obj.day}
				dayChange={dayChange}
				/>
		</Fragment>
	);
});
	
const DetValueDatePicker = observer((props) => {
	const gStorage = useGlobalStorage();
	const ne = gStorage.notify.notification.elem[props.ind];
	const {t} = useTranslation('obs');

	function onKeyDown (e) {
		e.preventDefault();
	}

	function detDateChanged(value) {
		console.log('detDateChanged', value, Math.round(value.toSeconds()));
		gStorage.notify.setTgtEDate(props.ind, value);
	}

	if (ne.t_id !== 10)
		return null;

	return (
		<DesktopDatePicker sx={{m:1,width:280}}
			label={t('notify.date')}
			format='dd.MM.yyyy'
			defaultValue={DateTime.now()}
			value={DateTime.fromISO(ne.val_obj)}
			onChange={detDateChanged}
			slotProps={{ 
				textField: { 
					size: 'small',
					onKeyDown: onKeyDown
				} 
			}}
		/>
	);
});

const DetValueTimePicker = observer((props) => {
	const gStorage = useGlobalStorage();
	const ne = gStorage.notify.notification.elem[props.ind];
	const {t} = useTranslation('obs');

	function detTimeChanged(value) {
		console.log('detTimeChanged', value);
		gStorage.notify.setTgtETime(props.ind, value);
	}

	if (ne.t_id !== 13)
		return null;

	return (
		<DesktopTimePicker
			label={t('notify.time')}
			ampm={false}
			ampmInClock={false}
			value={DateTime.fromISO(ne.val_obj)}
			onChange={detTimeChanged}
			slotProps={{ textField: { 
				size: 'small',
				sx: {m:1,width:280}
			} }}
		/>
	);
});

const DetValueAutoComplete = observer((props) => {
	const gStorage = useGlobalStorage();
	const ne = gStorage.notify.notification.elem[props.ind];
	const tgt_l = gStorage.notify.options[ne.t_id].tgt_list;
	const {t} = useTranslation('obs');

	function detIsOptionEqualToValue(dt, val) {
// 		console.log('detIsOptionEqualToValue', dt, val);
		return dt.id === val.id;
	}

	function detGetOptionValLabel(option) {
// 		console.log('ne', ne, 'ne.t_id', ne.t_id);

		if (ne.t_id === 4) {
			return option.nick;
		} else if (ne.t_id === 5) {
			return getCityName(option, gStorage.conn.user);
		} else if (ne.t_id === 14) {
			let name = option.last_name;

			if (name.length && option.first_name.length)
				name += ' ';

			return name + option.first_name;
		}

		return getShortSpecName(option, gStorage.conn.user);
	}

	function detValChange(e, value) {
// 		console.log('detValChange', value);

		gStorage.notify.setTgtEValue(props.ind, value);
	}

	if (ne.t_id < 4 || ((ne.t_id > 9) && ne.t_id !== 14))
		return null;

	return (
		<Autocomplete
			sx={{m:1,p:0,width:282}}
			size='small'
			options={tgt_l}
			getOptionLabel={detGetOptionValLabel}
			value={ne.val_obj}
			isOptionEqualToValue={detIsOptionEqualToValue}
			disabled={!tgt_l || tgt_l.length < 1}
			onChange={detValChange}
			renderInput={params => (
					<TextField {...params} label={t('notify.value')} variant="outlined" size="small" fullWidth />
				)}/>
	);
});

const NotifyDetRow = observer((props) => {
	const gStorage = useGlobalStorage();
	const ne = gStorage.notify.notification.elem[props.ind];
	const ol = gStorage.notify.options[ne.t_id].o_list;
	const {t} = useTranslation('obs');

// console.log('ne.t_id', ne.t_id, 'options', gStorage.notify.options[ne.t_id].tgt_list);

	function detTypeChange(e) {
		gStorage.notify.setTgtEType(props.ind, parseInt(e.target.value, 10));
	}

	function detOperChange(e) {
		gStorage.notify.setTgtEOp(props.ind, parseInt(e.target.value, 10));
	}

	function detDeleteRow() {
		let chain = JSON.parse(JSON.stringify(gStorage.notify.notification));

		chain.elem.splice(props.ind, 1);
		chain.modified = true;

		gStorage.notify.extEditTarget(chain);
	}

	function detActiveChanged(e, value) {
		gStorage.notify.setTgtEActive(props.ind, value ? 1 : 0);
	}

	return (
		<Card variant='outlined' sx={{width:300, border:1,m:1}}>
			<CardContent sx={{p:0}}>
				<Select
					sx={{width:180, m:1,p:0}}
					size='small'
					native
					value={ne.t_id}
					onChange={detTypeChange}>
						{ntype_list.map((dt, i) => {
							return 	(<option key={dt.id} value={dt.id}>{t('notify.' + dt.type)} </option>);
						})}
				</Select>
				<Select 
					sx={{width:84, m:1,p:0}}
					size='small'
					native
					value={ne.o_id}
					onChange={detOperChange}
					disabled={!ol || ol.length < 1}>
						{ol && ol.map((dt, i) => {
							return 	(<option key={dt.id} value={dt.id}>{dt.oper} </option>);
						})}
				</Select>
				<DetValueAutoComplete {...props}/>
				<DetValueDatePicker {...props}/>
				<DetValueDayMonthPicker {...props}/>
				<DetValueTimePicker {...props}/>
				<FormControlLabel
					sx={{m:1,ml:2,mt:0,p:0}}
					label={t('notify.active')}
					labelPlacement="start"
					checked={!!ne.active}
					onChange={detActiveChanged}
					control={<Checkbox color="primary" />}
				/>
			</CardContent>
			<CardActions sx={{p:0}}>
				<Button 
					size="small" 
					sx={{ml:1,mb:1}}
					onClick={detDeleteRow}
				>
					{t('notify.delete')}
				</Button>
			</CardActions>
		</Card>
	)
});

const NotifyDialog = observer((props) => {
	const {isOpen, handleClose} = props;
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const n = gStorage.notify.notification;

	function notifyRxWs(status, msg) {
		if (status !== COMM_OK) {
			alert('Notification Rx timeout!');
			return -1;
		}

		if (msg.cmd === 'notify') {
			if (msg.op === 'save_notification') {
				if (msg.result === 'OK') {
					handleClose(true);
				} else {
					alert('Notification save failed!');
				}
			} else if (msg.op === 'del_notification') {
				if (msg.result === 'OK') {
					handleClose(true);
				} else {
					alert('Notification delete failed!');
				}
			} else {
				console.error('notifyRxWs: unknown operation:', msg.cmd, msg.op);
			}
		}
	}

	function notifyDescChanged(e) {
		if (!gStorage.conn.online)
			return;

		gStorage.notify.setTgtDesc(e.target.value);
	}

	function elemIsValid(ne) {
// 		console.log('ne', ne);
		return ne.t_id && ne.o_id && ne.value;
	}

	function rowIsValid() {
		if (!n)
			return false;

		if (!n.desc || n.desc.length < 1)
			return false;

		if (n.elem.length < 1)
			return false;

		let valid = true;

		n.elem.forEach((ne) => {
			if (!elemIsValid(ne)) {
				valid = false;
			}
		})

		return valid;
	}

	function notifyAddElem() {
// 		console.log('notifyAddElem');

		let chain = JSON.parse(JSON.stringify(gStorage.notify.notification));

		chain.elem.push({id:0,t_id:4,o_id:1,value:0,negate:0,active:1,val_obj:null});
		chain.modified = 1;

		gStorage.notify.extEditTarget(chain);
	}

	function saveNotification() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'notify',
			op: 'save_notification',
			data: {
				user: gStorage.conn.user,
				notification: n,
			}
		};

// 		console.log('saveNotification', msg);
		gStorage.conn.ws.send(msg, notifyRxWs);
	}

	function delNotification() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'notify',
			op: 'del_notification',
			data: {
				user: gStorage.conn.user,
				notification: n,
			}
		};

// 		console.log('delNotification', msg);
		gStorage.conn.ws.send(msg, notifyRxWs);
	}

	return (
		<LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={'fi'}>
			<Dialog onClose={() => handleClose(false)} aria-labelledby="notify-dialog" open={isOpen ? true : false} PaperProps={{sx: {margin: 0, padding: 0}}} >
				<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} style={{width:316}}>
					<AppBar position="sticky">
						<Toolbar variant="dense">
							<Typography variant="h6" style={{flexGrow: 1, textAlign: 'center'}}>{t('notify.notification')}</Typography>
							<IconButton edge="start" color="inherit" onClick={() => handleClose(false)} aria-label="close">
								<CloseIcon />
							</IconButton>
						</Toolbar>
					</AppBar>
					<Grid size={{xs: 12}} align={'center'}>
						<TextField 
							label={t('common.name')}
							variant="outlined"
							value={n.desc}
							onChange={notifyDescChanged}
							size="small"
							style={{width: 300, margin: 4, marginTop: 16}} 
						/>
					</Grid>
					<Grid size={{xs: 12}} align={'left'}>
						<Button size="small" sx={{ml:1,mb:0,mt:1}} onClick={notifyAddElem}>
							{t('notify.add_row')}
						</Button>
					</Grid>
					{
						n && n.elem && n.elem.map((ne, ind) => {
							return (<NotifyDetRow key={ind} ind={ind}/>);
						})
					}
					<Grid size={{xs: 12}} align={'center'}>
						<div>
							<Button 
								variant="contained" 
								color="primary" 
								size="small" 
								style={{width:143, margin: 4}} 
								disabled={
									!gStorage.conn.online ||
									!rowIsValid() ||
									!n.modified}
								onClick={saveNotification}>
									{t('notify.save')}
							</Button>
							<Button 
								variant="contained" 
								color="primary" 
								size="small" 
								style={{width:143, margin: 4}} 
								disabled={
									!gStorage.conn.online ||
									!n.id}
								onClick={delNotification}>
									{t('notify.delete')}
							</Button>
						</div>
					</Grid>
				</Grid>
			</Dialog>
		</LocalizationProvider>
	);
});

export default NotifyDialog;
